/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetLinkingsListShowPreviousLinkings: "asset-linkings-list-show-previous-linkings",
  assetLinkingsListLinkAssets: "asset-linkings-list-link-assets",
} as const;
